import React, { useEffect } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Icon } from '@iconify/react';
import "./styles.css"
import { useTranslation } from 'react-i18next';
import { Block, Inline } from '@comp/crRender';

const isValidDate = (d) => d instanceof Date && !isNaN(d)

const toDateBound = (value, isMin) => {
  if (isValidDate(value)) return value

  if (typeof value === 'number') {
    return new Date(value, isMin ? 0 : 11, isMin ? 1 : 31)
  }

  const parsed = new Date(value)
  if (isValidDate(parsed)) return parsed

  const year = new Date().getFullYear()
  return new Date(year, isMin ? 0 : 11, isMin ? 1 : 31)
}

const DatePickerr = ({
  minDate = new Date().getFullYear(),
  maxDate = new Date().getFullYear(),
  disabled,
  isRequired = true,
  className = "",
  formHandler,
  name,
  isSingle,
  defaultValue,
  placeholder,
  showLabel = true,
  onApply,
}) => {

  const { t } = useTranslation()
  const { formValues = {}, handleFormValues } = formHandler

  const setValue = (value, options = {}) => {
    if (!name || !handleFormValues) return
    handleFormValues(name, { value, isRequired, isError: false }, options)
    onApply?.(value)
  }

  useEffect(() => {
    setValue(isSingle ? null : { from: null, to: null }, { markAsTouched: false })
  }, [])

  useEffect(() => {
    if (defaultValue) setValue(defaultValue, { markAsTouched: false })
  }, [defaultValue])

  const value = formValues[name]?.value
  const error = formValues[name]?.isError

  return (
    <div className={`DatePickerContainer col-md-4 ${className}`}>

      {name && showLabel && (
        <Block className="col-sm-12 default-label">
          <span className='date-picker-label'>{t(name)}</span>
          {isRequired && <Inline className="required">*</Inline>}
        </Block>
      )}

      <div className={`DatePicker ${error ? "field-required" : ""}`}>
        <DatePicker
          showIcon
          icon={<Icon icon="ci:calendar-days" className='DateIcon' />}
          className="dateInput"
          toggleCalendarOnIconClick
          selectsRange={!isSingle}
          placeholderText={placeholder || `${t('please-enter')} ${t(name)}`}
          startDate={!isSingle && value?.from}
          endDate={!isSingle && value?.to}
          selected={isSingle && value}
          showYearDropdown
          minDate={toDateBound(minDate, true)}
          maxDate={toDateBound(maxDate, false)}
          yearDropdownItemNumber={50}
          scrollableYearDropdown
          allowIconClick={false}
          disabled={disabled}
          onChange={(d) =>
            setValue(isSingle ? d : { from: d[0], to: d[1] })
          }
          dateFormat="dd/MM/yyyy"
        />
      </div>

    </div>
  )
}

export default DatePickerr
